import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";
import "../../styles/Admin.css";

const AdminLayout = () => {
  const adminToken = localStorage.getItem("adminToken");

  if (!adminToken) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="admin-layout">
      <AdminNavbar />
      <div className="admin-container">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;

